import {
  CLEAR_ONE_TIME_PAYMENT_VALUE,
  FETCH_ONE_TIME_PAYMENT_VALUE,
  ONE_TIME_PAYMENT_VALUE_FETCHED,
  ONE_TIME_PAYMENT_VALUE_FETCH_ERROR,
} from '../actions/billing/getOneTimePaymentValue';

const initialState = {
  fetched: false,
  price: null,
  error: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case CLEAR_ONE_TIME_PAYMENT_VALUE:
      return initialState;

    case FETCH_ONE_TIME_PAYMENT_VALUE:
      return initialState;

    case ONE_TIME_PAYMENT_VALUE_FETCHED:
      return {
        error: false,
        fetched: true,
        price: action.payload?.price,
      };

    case ONE_TIME_PAYMENT_VALUE_FETCH_ERROR:
      return {
        price: null,
        error: true,
        fetched: true,
      };
    default:
      return state;
  }
};
